import { render, staticRenderFns } from "./BFPATests.vue?vue&type=template&id=2dd7350e&scoped=true&"
import script from "./BFPATests.vue?vue&type=script&lang=js&"
export * from "./BFPATests.vue?vue&type=script&lang=js&"
import style0 from "./BFPATests.vue?vue&type=style&index=0&id=2dd7350e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7350e",
  null
  
)

export default component.exports